import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Button } from '@udemy/react-core-components';
import { LabIcon } from '../card-components/lab-icon.react-component';
import { LAB_LANDING_PAGE_URL } from '../constants';
import { sendReviewLabsBannerSelectedEvent, sendReviewLabsBannerDismissedEvent } from './events';
import styles from "./labs-learning-banner.module.css";
const MultipleLabsLearningBannerComponent = function (props) {
  const {
    gettext
  } = useI18n();
  const {
    store
  } = props;
  const redirectUrl = window.location.pathname === LAB_LANDING_PAGE_URL ? undefined : LAB_LANDING_PAGE_URL;
  async function onDismiss() {
    await store.setDismissed();
  }
  return /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": "labs-learning-banner",
    "data-testid": "multiple-labs-learning-banner"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(LabIcon, null), /*#__PURE__*/React.createElement("div", {
    className: styles['text-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: "ud-heading-md"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "multiple-labs-learning-banner"
  }, gettext('You still have time to pick up where you left off.'))), /*#__PURE__*/React.createElement("div", {
    className: "ud-text-md"
  }, gettext("Take a moment to review and keep making progress on the labs you've started."))), /*#__PURE__*/React.createElement("div", {
    className: styles['action-buttons']
  }, /*#__PURE__*/React.createElement(Button, {
    "data-purpose": "multiple-lab-banner-dismiss",
    onClick: async () => {
      await onDismiss();
      sendReviewLabsBannerDismissedEvent(true);
    },
    size: "medium",
    udStyle: "ghost",
    className: classNames('ud-link-neutral', styles['button'])
  }, gettext('Dismiss')), /*#__PURE__*/React.createElement(Button, {
    "data-purpose": "multiple-lab-banner-continue",
    onClick: () => {
      sendReviewLabsBannerSelectedEvent();
      onDismiss();
    },
    udStyle: "primary",
    size: "medium",
    componentClass: "a",
    href: redirectUrl
  }, gettext('Review labs')))));
};
MultipleLabsLearningBannerComponent.displayName = 'MultipleLabsLearningBanner';
export const MultipleLabsLearningBanner = observer(MultipleLabsLearningBannerComponent);
//# sourceMappingURL=multiple-labs-learning-banner.react-component.js.map